// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--47d2b";
export var footerBottom = "footer-module--footer-bottom--18634";
export var footerMenus = "footer-module--footer-menus--1d67d";
export var footerSocials = "footer-module--footer-socials--5eb09";
export var footerSocialsBottom = "footer-module--footer-socials-bottom--9d4e2";
export var footerSocialsTop = "footer-module--footer-socials-top--cd540";
export var footerTop = "footer-module--footer-top--2e5aa";
export var footerTopLogo = "footer-module--footer-top-logo--a4732";
export var footerTopNVerde = "footer-module--footer-top-n-verde--b195b";